import { useEffect, useMemo, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { Pagination } from 'antd'

import {
  useNavigate,
  useOutletContext,
  createSearchParams
} from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import AlertSuccess from '../../../../alert/AlertSuccess'
import Error_false from '../../../../components/error/error-false'
import ModalApproveItem from '../../../../components/ModalApproveItem'
import BtnBack2 from '../../../../components/btn-back2'
import NavTitle from '../../../../components/nav-title'
import CardCustom from '../../../../components/custom/card-custom'
import {
  getLeveTypeV2API,
  putAssignLeveTypeV2API
} from '../../../../services/setting/leave'
import CheckResponsiveDesktop from '../../../../helper/fnCheckResponsiveDesktop'
import { FaRegSave } from 'react-icons/fa'
import GenericTable from '../../../../components/table'
import { TbListSearch } from 'react-icons/tb'
import RowPerPageCustom from '../../../../components/custom/RowPerPageCustom'
import { fnDateEn } from '../../../../helper/fnDateEn'
import TagOrgList from '../../../../components/custom/TagOrgListCustom'
import { PAGE_SETTING_LEAVE_ADD } from '../../../../router/routes'
import FormField from '../../../../components/input/form-field'
import BadgeStatus from '../../../../components/BadgeStatus'

export default function AssignSettingLeavePege() {
  const {
    control,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: { searchList: '' },
    mode: 'onChange' // ⭐ สำคัญ
  })
  const search = watch('searchList')
  const isDesktop = CheckResponsiveDesktop()
  const outletContext = useOutletContext()
  const orgRole = outletContext?.orgRole ?? []
  const roleId = useSelector((state) => state.roleReducer.role)
  const orgName =
    orgRole?.find((o) => String(o.org_id) === String(roleId))?.org ?? ''
  const { t } = useTranslation()
  const [details, setDetails] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isOpenButton, setIsOpenButton] = useState(true)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalRows, setTotalRows] = useState(0)
  const offset = useMemo(() => (page - 1) * limit, [page, limit])
  const [globalCheckedMap, setGlobalCheckedMap] = useState({})
  const [showAddAll, setShowAddAll] = useState({
    isShow: false,
    data: null
  })
  const formatDateRange = (start, end) => {
    if (!start && !end) return '-'
    const s = start ? fnDateEn(start).format('DD/MM/YYYY') : ''
    const e = end ? fnDateEn(end).format('DD/MM/YYYY') : ''
    return `${s}${s && e ? ' - ' : ''}${e}`
  }
  const navigate = useNavigate()

  useEffect(() => {
    if (!roleId) return
    const timer = setTimeout(() => {
      getIndexAssignLeave({
        offset,
        limit: limit,
        orgId: roleId,
        search: search || ''
      })
    }, 400)

    return () => clearTimeout(timer)
  }, [roleId, search, limit, page])
  const getIndexAssignLeave = async (body) => {
    setIsLoading(true)
    const res = await getLeveTypeV2API(body)
    setIsLoading(false)
    if (!res) return
    if (res.status) {
      const mapped = res.result.map((item) => {
        const id = item.leaveTypeId
        const checked = globalCheckedMap.hasOwnProperty(id)
          ? globalCheckedMap[id]
          : item.assign === true

        return { ...item, is_check: checked }
      })
      setDetails(mapped)
      setTotalRows(res.total)
    } else {
      setDetails([])
      setTotalRows(0)
    }
  }

  const goBack = () => {
    navigate(-1)
  }

  const columns = [
    {
      header: t('hrms_setting_leave_name_header'),
      minWidth: '190px',
      headerStyle: {
        textAlign: 'left',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    },
    {
      header: t('hrms_setting_leave_total_header'),
      className: 'text-center',
      minWidth: '80px',
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    },
    {
      header: t('hrms_setting_leave_emp_type_header'),
      className: 'text-center',
      minWidth: '60px',
      maxWidth: '60px',
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    },
    {
      header: t('hrms_setting_leave_effecttive-start-end_header'),
      className: 'text-center',
      minWidth: '180px',
      maxWidth: '180px',
      headerStyle: {
        textAlign: 'left',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    },
    {
      header: t('hrms_setting_leave_assign_to_header'),
      className: 'text-center',
      minWidth: '270px',
      maxWidth: '270px',
      headerStyle: {
        textAlign: 'left',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    },
    {
      header: t('hrms_setting_leave_status_header'),
      className: 'text-center',
      minWidth: '86px',
      maxWidth: '86px',
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    },

    {
      header: t('hrms_setting_leave_header_action'),
      className: 'text-center',
      minWidth: '86px',
      maxWidth: '86px',
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    }
  ]
  const renderLocationRow = (details, baseCell, onEdit, setIsExpanded) => {
    const nameCellStyle = (minWidth) => ({
      ...baseCell,
      minWidth,
      textAlign: 'left',
      whiteSpace: 'nowrap',
      padding: '16px 12px'
    })

    // const centerCellStyle = (minWidth) => ({
    //   ...borderStyle,
    //   minWidth,
    //   textAlign: 'center',
    //   verticalAlign: 'top',
    //   whiteSpace: 'nowrap',
    // })

    return (
      <>
        <td style={nameCellStyle('284px')}>
          <p
            className="mb-0 "
            style={{
              color: ' var(--color-on-base-content-high)'
            }}
          >
            <div className="d-flex gap-3 align-items-center">
              <div>
                <div style={{ fontSize: '14px', fontWeight: 400 }}>
                  {`${details.leaveType}` ?? '-'}
                </div>
              </div>
            </div>
          </p>
        </td>

        <td
          style={{
            ...nameCellStyle('80px'),
            maxWidth: '150px'
          }}
        >
          <p
            className="mb-0 font-small-2 text-center"
            style={{
              color: 'var(--color-on-base-content-high)'
            }}
          >
            {details.leaveTypeTotal ? `${details.leaveTypeTotal}` : '-'}
          </p>
        </td>
        <td style={nameCellStyle('110px')}>
          <p
            className="mb-0 font-small-2"
            style={{
              color: 'var(--color-on-base-content-high)',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            {details?.empType ? details.empType.typeName : '-'}
          </p>
        </td>

        <td style={nameCellStyle('180px')}>
          <p
            className="mb-0 font-small-2"
            style={{
              color: 'var(--color-on-base-content-high)'
            }}
          >
            {formatDateRange(details?.effectiveStart, details?.effectiveEnd)}
          </p>
        </td>

        <td style={nameCellStyle('284px')}>
          <TagOrgList orgAssign={details?.orgAssign} onExpand={() => setIsExpanded?.(true)} />
        </td>
        <td style={nameCellStyle('86px')}>
          <BadgeStatus
            isActive={details?.leaveTypeStatus}
            activeText={t('hrms_setting_leave_active_status')}
            inactiveText={t('hrms_setting_leave_inactive_status')}
          />
        </td>

        <td style={nameCellStyle('86px')}>
          <div className="d-flex justify-content-center w-100">
            <Button
              variant="light"
              className="text-primary rounded-2 px-2"
              style={{
                width: '40px',
                height: '32px',
                borderRadius: '8px',
                borderColor: 'var(--color-on-base-border-default)',
                backgroundColor: 'var(--color-base-foreground-elevated-16)'
              }}
              size="sm"
              onClick={() => onEdit?.(details?.leaveTypeId ?? '')}
            >
              <TbListSearch
                size={18}
                style={{
                  color: 'var(--color-on-base-content-high)'
                }}
              />
            </Button>
          </div>
        </td>
      </>
    )
  }
  const handleEditLocation = (d) => {
    navigate({
      pathname: PAGE_SETTING_LEAVE_ADD,
      search: `?${createSearchParams({
        id: d ?? '',
        page: 'assign'
      })}`
    })
  }
  const openConfirmModal = () => {
    const assign = []
    const unassign = []

    Object.entries(globalCheckedMap).forEach(([id, checked]) => {
      if (checked) assign.push(Number(id))
      else unassign.push(Number(id))
    })

    setShowAddAll({
      isShow: true,
      data: { org_id: Number(roleId), assign, unassign }
    })
  }

  const onSubmitUpdate = async (data) => {
    const body = {
      org_id: data.org_id,
      assign: data.assign,
      unassign: data.unassign
    }
    const resp = await putAssignLeveTypeV2API(body)
    if (!resp) return
    if (!resp.status) {
      Error_false(resp)
      return
    }
    AlertSuccess()
  }
  return (
    <>
      <Row>
        <NavTitle>
          <BtnBack2 onClick={goBack} text={t('hrms_setting_leave_topic')} />
        </NavTitle>
        <Col xl={12} className="mb-3">
          <CardCustom minHeight="">
            <div>
              {/* ===== Filter + Add + Table ===== */}
              <div>
                <Row>
                  <Col
                    xl={12}
                    style={{
                      padding: '20px 0px 20px 45px'
                    }}
                  >
                    <span
                      style={{
                        fontSize: isDesktop ? 20 : 18,
                        fontWeight: 500,
                        color: 'var(--color-on-base-content-high)'
                      }}
                    >
                      {orgName}:
                    </span>
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 400,
                        color: 'var(--color-on-base-content-high)'
                      }}
                    >
                      {' '}
                      {t('hrms_setting_leave_list_header')}
                    </span>
                  </Col>
                  <Col
                    xl={12}
                    className="d-flex align-items-center justify-content-between px-5 pb-3"
                  >
                    <FormField
                      name="searchList"
                      style={{ width: isDesktop ? 500 : '100%' }}
                      control={control}
                      errors={errors}
                      placeholder={t('hrms_setting_leave_search')}
                    />
                    <Button
                      disabled={isOpenButton}
                      onClick={openConfirmModal}
                      style={{
                        height: 40,
                        padding: '0 16px',
                        borderRadius: 8,
                        fontSize: 14,
                        fontWeight: 500,
                        whiteSpace: 'nowrap',
                        cursor: 'pointer'
                      }}
                    >
                      <FaRegSave size={20} className="me-1" />{' '}
                      {t('hrms_setting_location_save_bt')}
                    </Button>
                  </Col>
                </Row>

                {/* ===== Table ===== */}
                <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
                  <GenericTable
                    rowKey="leaveTypeId"
                    checkbox={true}
                    setIsCheckDisable={setIsOpenButton}
                    data={details}
                    setData={setDetails}
                    columns={columns}
                    isLoading={isLoading}
                    rowStartIndex={(page - 1) * limit}
                    renderRow={(details, index, baseCell, activeTab, setIsExpanded) =>
                      renderLocationRow(
                        details,
                        baseCell,
                        handleEditLocation,
                        setIsExpanded
                      )
                    }
                    visible_rows={10}
                    onCheckedChange={(id, checked) => {
                      setGlobalCheckedMap(prev => ({ ...prev, [id]: checked }))
                    }}
                    onSelectAllChange={(items, checked) => {
                      setGlobalCheckedMap(prev => {
                        const next = { ...prev }
                        items.forEach(item => { next[item.leaveTypeId] = checked })
                        return next
                      })
                    }}
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                flexShrink: 0,
                borderTop: '1px solid var(--color-base-border-default)',
                padding: '0px 12px',
                boxShadow:
                  '0px 0px 1px 0px #0000001F, 0px 4px 16px -4px #00000014'
              }}
            >
              <Row
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  margin: 16
                }}
              >
                <Col xl={6} md={12}>
                  <RowPerPageCustom
                    onChange={(d) => {
                      setPage(1)
                      setLimit(d)
                    }}
                    currentSize={limit}
                  />
                </Col>
                <Col xl={6} md={12} className="d-flex justify-content-end">
                  <Pagination
                    size="small"
                    current={page}
                    pageSize={limit}
                    total={totalRows}
                    showSizeChanger={false}
                    onChange={(p) => {
                      setPage(p)
                    }}
                  />
                </Col>
              </Row>
            </div>
          </CardCustom>
        </Col>
      </Row>
      {showAddAll.isShow && (
        <ModalApproveItem
          open={showAddAll.isShow}
          data={showAddAll.data}
          onConfirm={onSubmitUpdate}
          fnDone={() => {
            setShowAddAll({ isShow: false, data: null })
            getIndexAssignLeave({
              limit,
              offset: 0,
              orgId: Number(roleId),
              search: search || ''
            })
            navigate('/setting/leave/org')
          }}
          onCancel={() => {
            setShowAddAll({ isShow: false, data: null })
          }}
          cancelText={t('hrms_setting_leave_cr_org_no_bt')}
          confirmText={t('hrms_setting_leave_cr_org_yes_bt')}
          title={t('hrms_setting_leave_modal_cr_org_title')}
          subTitle={t('hrms_setting_leave_modal_cr_org_sub_title')}
        />
      )}
    </>
  )
}
